import { useEffect, useState } from "react";
import { Get_All_From_MongoDB } from "../Staff/api/Get_All_From_MongoDB";
import { StaffuseAuth } from "../Staff/security/StaffuseAuth";

function ArrAllProgrammesFiltered(
  ProgrammeAge,
  ProgrammeType,
  ProgrammeTitle,
  ProgrammeDate,
  ProgrammeLength,
  ProgrammeAccom,
  ProgrammeAirport,
  ProgrammeVarient
) {
  //Filter Array
  //let ArrAllProgrammesFiltered = ArrAllProgrammes;
  const { logout } = StaffuseAuth();

  const [data, setdata] = useState([]);
  useEffect(() => {
    Get_All_From_MongoDB("Lookups", "Programmes_2025", setdata, logout);
  }, []);

  //Filter Array
  let ArrAllProgrammesFiltered = data;

  if (ProgrammeAge === "15-18") {
    ArrAllProgrammesFiltered = ArrAllProgrammesFiltered.filter((Varient) =>
      Varient.Age.includes("15-18")
    );
  }
  if (ProgrammeAge === "18+") {
    ArrAllProgrammesFiltered = ArrAllProgrammesFiltered.filter((Varient) =>
      Varient.Age.includes("18+")
    );
  }
  if (ProgrammeType === "SXP") {
    ArrAllProgrammesFiltered = ArrAllProgrammesFiltered.filter((Varient) =>
      Varient.Type.includes("SXP")
    );
  }
  if (ProgrammeType === "Weekend") {
    ArrAllProgrammesFiltered = ArrAllProgrammesFiltered.filter((Varient) =>
      Varient.Type.includes("Weekend")
    );
  }

  //Get Titles
  let ArrAllProgrammesFiltered_Titles = ArrAllProgrammesFiltered.map(
    (Varient) => Varient.Title
  );
  ArrAllProgrammesFiltered_Titles = ArrAllProgrammesFiltered_Titles.filter(
    (value, index, self) => self.indexOf(value) === index
  );

  //Get Varients
  let ArrAllProgrammesFiltered_Varients = ArrAllProgrammesFiltered.map(
    (Varient) => Varient.Varient.toLowerCase()
  );
  ArrAllProgrammesFiltered_Varients = ArrAllProgrammesFiltered_Varients.filter(
    (value, index, self) => self.indexOf(value) === index
  );

  //Use Titles to get availible Dates
  let ArrAllProgrammesFiltered_TitleFilter = ArrAllProgrammesFiltered;
  if (ProgrammeTitle) {
    ArrAllProgrammesFiltered_TitleFilter = ArrAllProgrammesFiltered.filter(
      (Varient) => Varient.Title.includes(ProgrammeTitle)
    );
  }
  //Get Dates
  let ArrAllProgrammesFiltered_Dates = ArrAllProgrammesFiltered_TitleFilter.map(
    (Varient) => Varient.Dates
  );
  ArrAllProgrammesFiltered_Dates = ArrAllProgrammesFiltered_Dates.filter(
    (value, index, self) => self.indexOf(value) === index
  );

  return {
    ArrAllProgrammesFiltered: ArrAllProgrammesFiltered,
    ArrAllProgrammesFiltered_Varients: ArrAllProgrammesFiltered_Varients,
    ArrAllProgrammesFiltered_Titles: ArrAllProgrammesFiltered_Titles,
    ArrAllProgrammesFiltered_Dates: ArrAllProgrammesFiltered_Dates,
  };
}

export default ArrAllProgrammesFiltered;
